export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10222.8652e805.jpg";